import axiosInstance from "../../../http-common";
import { v4 } from "uuid";
import { logout_if_403 } from "../../../util";

export const getErrorMessage = (error) => {
  if (error instanceof Error) return error.message;
  return String(error);
};
export const load_ud_data_from_backend = async (data, setData, tabName) => {
  // console.log("loading po from backend");
  try {
    const result = await axiosInstance.get(`v1/qc/backlog_po/${tabName}?role=ud`);
    // console.log(result);
    if (result.data) {
      const tableData = result.data?.data
        ?.filter((item) => item.remark === "Under UD")
        .map((item) => ({ ...item, id: v4() }));
      // console.log(tableData);
      if (
        result["data"]?.["data"] &&
        setData &&
        typeof setData === "function"
      ) {
        setData(tableData);
      }
    }
  } catch (error) {
    logout_if_403(error);
    console.log(getErrorMessage(error));
    // dispatch(po_load_failure_action(err));
  }
};

// to get hidden columns
export const getHiddenColumnsUD = async (data, setData) => {
  try {
    const result = await axiosInstance.get(`v1/qc/get_hidden_fields`);
    // console.log(result);
    if (result.data) {
      if (
        result["data"]?.["data"] &&
        setData &&
        typeof setData === "function"
      ) {
        const columnsData = result?.data?.data?.ud;
        if (columnsData && Object.keys(columnsData).length > 0) {
          const hiddenColumns = columnsData.reduce((acc, columnName) => {
            acc[columnName] = false;
            return acc;
          }, {});
          setData(hiddenColumns);
        } else {
          console.log("Columns data is empty.");
          setData({});
        }
      }
    }
  } catch (error) {
    const err = getErrorMessage(error);
    console.log({ error: err });
  }
};

export const edit_ud_schedule = async ({
  batch_number,
  field_to_update,
  qc_receive_date,
  material_type,
}) => {
  const body = {
    batch_number,
    field_to_update,
    value: qc_receive_date,
    material_type,
  };
  // console.log(body);
  const response = await axiosInstance.patch(`/v1/qc/backlog_po/`, body);
  const result = (await response).data;
  const { status, error } = result;
  if (status === "success") {
    return {
      status: true,
      message: "Date Updated Successfully",
    };
  }
  return {
    status: false,
    message: error,
  };
};
